<template>
  <div v-if="step1">
    <div class="bg-white padding" style="position: relative; z-index: 2" ref="card" v-show="carNumberList.length">
      <div class="input-item flex">
        <div style="display: flex">
          <div class="line"></div>
          <span class="text-nowrap">已綁定車輛</span>
        </div>
        <div>
          <span style="float: right; font-size: 16px" class="text-blue" @click="changeModifyListStatus">{{ isModifing ? '完成' : '編輯' }}</span>
        </div>
      </div>
      <div class="dark-card">
        <div v-for="(item, i) in carNumberList" :key="i" class="flex border">
          <div>
            <div>{{ item.car_number }}</div>
            <div style="font-size: 14px; color: #c7c7c7">{{ getCarTypeName(item.car_type, item.car_number) }}</div>
          </div>
          <div class="delete" v-if="isModifing" @click="removeFavoriteCarNumber(item.car_number_serial_number)"></div>
          <div class="active" @click="getBillIsNull(false, item.car_type, item.car_number)" v-else>查詢</div>
        </div>
      </div>
    </div>
    <div class="padding bg-white">
      <div class="input-item flex">
        <div style="display: flex" class="text-nowrap">
          <div class="line"></div>
          {{ carNumberList.length>0 ? '查詢其他車輛' : '請輸入車輛資訊' }}
        </div>
        <div class="icon-scan" @click="openScanner" v-if="this.isScanEnabled()">掃描</div>
      </div>

      <div class="form">
        <roadside-parking-form :form="form" @getFormData="getFormData" @isValidSlowVehicleNumber="isValidSlowVehicleNumber" :is-trailer-enabled="this.isTrailerEnabled()" :is-heavy-motorcycle-enabled="this.isHeavyMotorcycleEnabled()" :is-slow-vehicle-enabled="this.isSlowVehicleEnabled()"></roadside-parking-form>
        <div class="agree-label" style="margin: 16pt 0">
          <input type="checkbox" id="agree_add_favorite" v-model="isAddFavoriteChecked" />
          <label for="agree_add_favorite" v-if="this.cityId==='taipei'">記住車號，下次繳費無需再重新輸入</label>
          <label for="agree_add_favorite" v-if="this.cityId!=='taipei'">綁定車號，新停車單自動通知</label>
        </div>
        <button class="btn btn-primary" :disabled="isDisabled" @click="clickAddFavoriteAndStepNext">查詢待繳帳單</button>
      </div>
    </div>
    <div class="padding description">
      <ul class="text-gray2" v-if="this.cityId==='taipei'">
        <li>僅提供帳單開立隔日後之台北市路邊臨時停車費查詢繳費。</li>
        <li>不提供已逾期限之帳單繳費。</li>
        <li>重型機車車種請選擇機車。</li>
      </ul>
      <ul class="text-gray2" v-if="this.cityId==='tainan'">
        <li>綁定生效後（作業需 1-2 個工作天），目前僅可接收「臺南市路邊停車費」待繳帳單推播通知。</li>
        <li>同一車號一天內，僅提供綁定及解綁申請各一次。</li>
        <li>若已設定銀行自動扣繳，請勿重複繳費。</li>
      </ul>
      <ul class="text-gray2" v-if="this.cityId==='hsinchu'">
        <li>綁定生效後（作業需 1-2 個工作天），即可接收「新竹縣路邊停車費」待繳帳單推播通知。</li>
        <li>同一車號一天內，僅提供綁定及解綁申請各一次。</li>
        <li>若已設定銀行自動扣繳，請勿重複繳費。</li>
        <li>新竹縣拖車停車費，目前尚未開放新停車單自動推播通知，請自行查詢待繳帳單並完成繳費</li>
      </ul>
      <ul class="text-gray2" v-if="this.cityId==='hsinchuCity'">
        <li>綁定生效後（作業需 1-2 個工作天），即可接收「新竹市路邊停車費」待繳帳單推播通知。</li>
        <li>同一車號一天內，僅提供綁定及解綁申請各一次。</li>
        <li>若已設定銀行自動扣繳，請勿重複繳費。</li>
      </ul>
      <ul class="text-gray2" v-if="this.cityId==='kaohsiung'">
        <li>綁定生效後（作業需 1-2 個工作天），即可接收「高雄市路邊停車費」待繳帳單推播通知。</li>
        <li>同一車號一天內，僅提供綁定及解綁申請各一次。</li>
        <li>若已設定銀行自動扣繳，請勿重複繳費。</li>
      </ul>
      <ul class="text-gray2" v-if="this.cityId==='nantou'">
        <li>綁定生效後（作業需 1-2 個工作天），即可接收「南投縣路邊停車費」待繳帳單推播通知。</li>
        <li>同一車號一天內，僅提供綁定及解綁申請各一次。</li>
        <li>若已設定銀行自動扣繳，請勿重複繳費。</li>
      </ul>
      <ul class="text-gray2" v-if="this.cityId==='newTaipeiCity'">
        <li>綁定生效後（作業需 1-2 個工作天），即可接收「新北市路邊停車費」待繳帳單推播通知。</li>
        <li>同一車號一天內，僅提供綁定及解綁申請各一次。</li>
        <li>若已設定銀行自動扣繳，請勿重複繳費。</li>
        <li>請確認車輛離場後，再繳納停車費。</li>
      </ul>
      <ul class="text-gray2" v-if="this.cityId==='taoyuan'">
        <li>綁定生效後（作業需 1-2 個工作天），即可接收「桃園市路邊停車費」待繳帳單推播通知。</li>
        <li>同一車號一天內，僅提供綁定及解綁申請各一次。</li>
        <li>若已設定銀行自動扣繳，請勿重複繳費。</li>
        <li>請確認車輛離場後，再繳納停車費。</li>
      </ul>
      <ul class="text-gray2" v-if="this.cityId==='keelung'">
        <li>綁定生效後（作業需 1-2 個工作天），即可接收「基隆市路邊停車費」待繳帳單推播通知。</li>
        <li>同一車號一天內，僅提供綁定及解綁申請各一次。</li>
        <li>若已設定銀行自動扣繳，請勿重複繳費。</li>
        <li>請確認車輛離場後，再繳納停車費。</li>
      </ul>
      <ul class="text-gray2" v-if="this.cityId==='taichung'">
        <li>綁定生效後（作業需 1-2 個工作天），即可接收「臺中市路邊停車費」待繳帳單推播通知。</li>
        <li>同一車號一天內，僅提供綁定及解綁申請各一次。</li>
        <li>若已設定銀行自動扣繳，請勿重複繳費。</li>
        <li>請確認車輛離場後，再繳納停車費。</li>
      </ul>
      <ul class="text-gray2" v-if="this.cityId==='yilan'">
        <li>綁定生效後（作業需 1-2 個工作天），即可接收「宜蘭縣路邊停車費」待繳帳單推播通知。</li>
        <li>同一車號一天內，僅提供綁定及解綁申請各一次。</li>
        <li>若已設定銀行自動扣繳，請勿重複繳費。</li>
        <li>請確認車輛離場後，再繳納停車費。</li>
      </ul>
    </div>
    <div :class="isModifing ? 'mask' : ''" ref="mask"></div>
  </div>
  <div v-else>
    <roadside-parking-step2 @citySelected="citySelected"></roadside-parking-step2>
  </div>
</template>

<script>
import RoadsideParkingForm from '../../components/RoadsideParkingForm';
import { saveFavoriteCarNumber, queryFavoriteCarNumber, deleteFavoriteCarNumber, queryBillList } from '../../api/api';
import RoadsideParkingStep2 from './RoadsideParkingStep2';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'roadside-parking-list',
  components: { RoadsideParkingStep2, RoadsideParkingForm },
  data() {
    return {
      carNumberList: [],
      isModifing: false,
      cityId: '',
      cityName: '',
      form: {
        carType: 'M',
        carNumber: '-',
      },
      isAddFavoriteChecked: true,
      step1: false,
    };
  },
  created() {
    this.getFavoriteCarNumber();
    window.getScanningResult = this.getScanningResult;
    if (this.$route.query.city_id !== undefined && this.$route.query.city_id !== '' &&
      this.$route.query.city_name !== undefined && this.$route.query.city_name !== ''
    ) {
      let cityId = this.$route.query.city_id;
      let cityName = this.$route.query.city_name;
      let scanResult = this.$route.query.scan_result;
      this.$router.replace({'query': null});

      this.citySelected(cityId, cityName);      
      if (scanResult !== undefined && scanResult !== '' ) {
        this.getScanningResult(scanResult);
      }
    }
  },
  mounted() {
    var height = this.$refs.card.clientHeight;
    this.$refs.mask.style.top = height + 'px';    
  },
  activated() {
    this.step1 = true;
    this.$store.dispatch('sentApp', {
      action: 'configureAppWebPage',
      payload: { title: '路邊臨時停車費', headerType: 'white' },
    });
  },
  computed: {
    ...mapGetters(['supportFeatures']),
    isDisabled() {
      if (this.form.carType === 'M1') {
        return !this.isValidSlowVehicleNumber(this.form.carNumber);
      } else {
        return this.form.carNumber.split('-')[0] === '' || this.form.carNumber.split('-')[1] === '';
      }
    },
  },

  methods: {
    ...mapActions(['setReadyToPayBill']),
    localCarTypeToCarType(carType) {
      switch (carType) {
        case 'M1':
          return 'M';
        default:
          return carType;
      }
    },
    isValidSlowVehicleNumber(carNumber) {
      const regexp = RegExp(/^[A-Z]{2}[0-9]{5}$/);      
      let result = regexp.test(carNumber);
      return result;
    },
    getCarTypeName(carType, carNumber) {
      switch(carType) {
        default:
        case 'C':
          return '汽車';
        case 'M':
          if (this.isValidSlowVehicleNumber(carNumber)) {
            return '微電車';
          }
          return '機車';
        case 'B':
          return '拖車';
        case 'H':
          return '重機';
        case 'M1':
          return '微電車';
      }
    },
    isSlowVehicleEnabled() {
      const targetDate = new Date('2025-05-01T00:00:00.000+08:00');
      const currentDate = new Date();
      
      // 比較兩個日期
     
      switch (this.cityId) {
        case 'newTaipeiCity':
            return true;
        case 'taichung':
        if (targetDate < currentDate) {
          return true;
        } else {
          return false;
        }
        default:
          return false;
      }
    },
    isTrailerEnabled() {
      switch (this.cityId) {
        case 'hsinchu':
        case 'kaohsiung':
        case 'taoyuan':
          return true;
        default:
          return false;
      }
    },
    isHeavyMotorcycleEnabled() {
      switch (this.cityId) {
        case 'yilan':
          return true;
        default:
          return false;
      }
    },
    isScanEnabled() {
      switch (this.cityId) {
        case 'taipei':
        case 'hsinchu':
        case 'hsinchuCity':
        case 'kaohsiung':
        case 'nantou':
        case 'newTaipeiCity':
        case 'taoyuan':
        case 'keelung':
        case 'taichung':
        case 'yilan':
          return true;
        default:
          return false;
      }
    },
    isQREnabled() {
      switch (this.cityId) {
        case 'taoyuan':
        case 'taichung':
          return true;
        default:
          return false;
      }
    },
    getFavoriteCarNumber() {
      if (this.cityId !== '') {
        queryFavoriteCarNumber(this.cityId).then((res) => {
          if (res.error == null) {
            this.carNumberList = res.car_number_list;
            setTimeout(() => {
              var height = this.$refs.card.clientHeight;
              this.$refs.mask.style.top = height + 'px';
            }, 1000);
          }
        });
      }
    },
    changeModifyListStatus() {
      this.isModifing = !this.isModifing;
    },

    addCarNumberToFavorite() {
      let carType = this.localCarTypeToCarType(this.form.carType);
      var form = {
        car_type: carType,
        car_number: this.form.carNumber,
      };
      if (this.form.carNumber.length>8) {
        alert('請輸入正確的車牌號碼');
        return false;
      }
      saveFavoriteCarNumber(this.cityId, form).then((res) => {
        if (res.error != null) {
          alert(res.error.message);
        }
        this.getBillIsNull(false, carType, this.form.carNumber);
      });
    },
    clickAddFavoriteAndStepNext() {    
      if (this.isAddFavoriteChecked) {
        if (this.cityId === 'hsinchu' && this.form.carType === 'B') {
          alert('新竹縣拖車停車費目前未開放新停車單自動通知喔！');
        }
        this.addCarNumberToFavorite();
      } else {
        this.getBillIsNull(false, this.form.carType, this.form.carNumber);
      }
    },
    getFormData(fieldName, data) {
      this.form[fieldName] = data;
    },
    removeFavoriteCarNumber(carNumberSerialNumber) {
      if (confirm('確定要刪除？')) {
        deleteFavoriteCarNumber(this.cityId, { car_number_serial_number: carNumberSerialNumber }).then((res) => {
          if (res.error == null) {
            this.isModifing = false;
            this.getFavoriteCarNumber(this.cityId);
          } else {
            alert(res.error.message);
          }
        });
      }
    },
    openScanner() {
      let scannerType = this.supportFeatures.scanningv3 && this.isQREnabled() ? 6 : 2;
      this.$store.dispatch('sentApp', {
        action: 'openScanner',
        payload: { type: scannerType },
      });
    },
    getScanningResult(paymentCustomId) {
      if (this.cityId === 'taoyuan') {
        if (paymentCustomId.startsWith('https://epark.tycg.gov.tw/public_bak/TPrint2.aspx')) {
          const url = new URL(paymentCustomId);
          const params = new Proxy(new URLSearchParams(url.search), {
            get: (params, prop) => params.get(prop),
          });
          let value = params.tkt_no2;
          if (value !== undefined && value.length === 15) {
              paymentCustomId = value;
          } else {
            return;
          }
        }
      } else if (this.cityId === 'taichung') {
        if (paymentCustomId.startsWith('TCParking,')) {
          paymentCustomId = paymentCustomId.split(',')[1];
        } 
      }
      this.getBillIsNull(true, '', paymentCustomId);
    },
    citySelected(cityId, cityName) {
      this.cityId = cityId;
      this.cityName = cityName;
      this.step1 = true;
      this.getFavoriteCarNumber();
    },
    getPaymentItemId() {
      if (this.cityId === 'taipei') {
        return 2;
      } else if (this.cityId === 'tainan') {
        return 'tainan-CAR';
      } else if (this.cityId === 'hsinchuCity') {
        return 'hsinchuCity-CAR';
      } else if (this.cityId === 'hsinchu') {
        return 'hsinchu-CAR';
      } else if (this.cityId === 'kaohsiung') {
        return 'kaohsiung-CAR';
      } else if (this.cityId === 'nantou') {
        return 'nantou-CAR';
      } else if (this.cityId === 'newTaipeiCity') {
        return 'newTaipeiCity-CAR';
      } else if (this.cityId === 'taoyuan') {
        return 'taoyuan-CAR';
      } else if (this.cityId === 'keelung') {
        return 'keelung-CAR';
      } else if (this.cityId === 'taichung') {
        return 'taichung-CAR';
      } else if (this.cityId === 'yilan') {
        return 'yilan-CAR';
      }
      return 2;
    },
    getBillIsNull(isScanning, carType, carNumber) {
      if (!isScanning && carNumber.length>8) {
        alert('請輸入正確的車牌號碼');
        return false;
      }
      var form = {
        payment_item_id: this.getPaymentItemId(),
        payment_query_type: isScanning ? 2 : 1,
        parameter1: this.localCarTypeToCarType(carType),
        parameter2: carNumber,
        parameter3: '',
        payment_custom_id: isScanning ? carNumber : '',
      };
      queryBillList(form).then((res) => {
        if (res.error === undefined) {
          this.setReadyToPayBill(res);
          if (isScanning) {
            this.$router.push({
              path: '/goPay',
              query: {
                payment_item_id: this.getPaymentItemId(),
                parameter1: res.car_type,
                parameter2: res.car_number,
                roadside_city: this.cityName,
                payment_custom_id: carNumber, 
                payment_query_type: 2,
              },
            });
          } else {
            this.$router.push({
              path: '/goPay',
              query: {
                payment_item_id: this.getPaymentItemId(),
                parameter1: this.localCarTypeToCarType(carType),
                parameter2: carNumber,
                roadside_city: this.cityName,
                payment_query_type: 1,
              },
            });
          }
        } else {
          alert(res.error.message);
          this.getFavoriteCarNumber(this.cityId);
          this.step1 = true;
        }
      });
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dark-card .flex {
  padding: 9pt 0;
  border-bottom: 1px solid rgba(64, 64, 64, 0.75);
}
</style>
